import React from 'react';
import '.././App.css';
import ReactHtmlParser, { processNodes, convertNodeToElement } from 'react-html-parser';


import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

const Product = (props: any) => {

  const link = "/product-detail/"+props.id;

  let imageLink:any = '';

  if(props.image !== null){

    imageLink = <img className="card-img-top custom-radius-top" src={'http://api-balony.techcrowd.cz/' + props.image} />;

  }

  return (
    <div className="col-12 col-lg-4 my-3">
      <div className="card h-100 border-0 custom-radius custom-shadow">
        <div className="img-container-16-9 img-container custom-radius-top">{imageLink}</div>
        <div className="card-body d-flex flex-column justify-content-between">
        <div className="mb-4 mt-2">
        <h2 className="mb-3">{props.name}</h2>
        <p className="text-secondary">{ReactHtmlParser(props.description)}</p>
        </div>
        <div className="d-flex justify-content-between">
        <div className="pt-1 text-secondary fs-4">cena {props.price} kč</div>
        <div><Link className="btn rounded-pill btn-primary" to={link} >Prozkoumat</Link></div>
        </div>
        </div>
      </div>
    </div>
  );

}

export default Product;
